import axiosConfig from "@/data/utils/axiosConfigInstance";
import { useCallback, useEffect, useRef, useState } from "react";
import {toast} from "react-toastify";
import { MUX_UPLOAD_STATUS } from '@/constants/muxUploadStatus';

export const useMuxDirectUpload = () => {
  const [state, setState] = useState({
    url: '',
    id: '',
    loading: false,
    polling: false,
  });
  const pollRef = useRef(null);

  const init = useCallback(async (title) => {
    if (!title?.trim()) return null;
    setState((s) => ({ ...s, loading: true }));
    try {
      const res = await axiosConfig.post(
        `${import.meta.env.VITE_APP_API_URL}/admin/direct-upload`,
        { title }
      );
      const { url, uploadId } = res?.data?.data || {};
      setState({ url: url || '', id: uploadId || '', loading: false, polling: false });
      return { url, uploadId };
    } catch (e) {
      toast.error('Failed to create Mux direct upload endpoint' + (e?.message ? ` (${e.message})` : ''));
      setState((s) => ({ ...s, loading: false }));
      return null;
    }
  }, []);

  const startPolling = useCallback(({ uploadId, onReady }) => {
    if (!uploadId) {
      return;
    }
    if (pollRef.current) {
      clearInterval(pollRef.current);
      pollRef.current = null;
    }
    setState((s) => ({ ...s, polling: true }));

    pollRef.current = setInterval(async () => {
      try {
        const res = await axiosConfig.get(
          `${import.meta.env.VITE_APP_API_URL}/admin/direct-upload/${uploadId}`
        );
        const d = res?.data?.data;
        if (d?.status === MUX_UPLOAD_STATUS.READY) {
          clearInterval(pollRef.current);
          pollRef.current = null;
          setState((s) => ({ ...s, polling: false }));
          onReady?.(d.muxVideoLink, d.duration, d.playback_id);
        }
      } catch {
        // keep polling
      }
    }, 4000);
  }, []);

  useEffect(() => {
    return () => {
      if (pollRef.current) clearInterval(pollRef.current);
    };
  }, []);

  return { mux: state, setMux: setState, init, startPolling };
}